module.exports = __webpack_public_path__ + "img/logo.0a8dc232.png";